import styled from "styled-components";
import {
  blue,
  green,
  grey,
  lightgrey,
  orange,
} from "../../styles/variables.style";

// black : #101820;
//jaune : #FFA400;
//vert : #2CC84D;
//bleu : #4ca6e2;

export const SectionTarifsWrapper = styled.div`
  margin-left: 25%;
  margin-right: 25%;
  margin-top: 50px;

  .isMensuelWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .switch {
      text-align: center;
      margin-bottom: 20px;
    }
    .ant-switch {
      background-color: #ffa400;
      width: 100px;
      height: 30px;
      font-weight: bold;
    }
    .ant-switch-checked {
      background: #4ca6e2;
    }
    .ant-switch-handle {
      margin-top: 4px;
    }
    .ant-switch-checked {
      .ant-switch-handle {
        left: calc(100% - 21px);
      }
    }
    > span {
      font-weight: bold;
      font-style: italic;
      ${"" /* color: dimgray; */}
    }
  }

  .ant-collapse {
    border-radius: 10px;
    margin-top: 20px;
    &,
    .ant-collapse-item,
    .ant-collapse-content {
      border-color: #e8e8e8;
    }

    > div:last-child {
      &,
      .ant-collapse-content {
        border-radius: 0px 0px 10px 10px;
      }
    }

    .pricingCollapseHeader {
      display: flex;
      width: 100%;
      border-bottom: 1px #e8e8e8 solid;
      p {
        margin: 0px;
        font-weight: bold;
        &.description {
          ${"" /* font-weight: normal; */}
          color: white;
        }
      }
      > div {
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
      }
    }

    .features {
      flex: 2;
      flex-direction: row;
    }

    .basic {
      flex: 1;
      background: ${orange};
    }

    .essential {
      flex: 1;
      background: ${green};
    }

    .premium {
      flex: 1;
      background: ${blue};
      border-radius: 0px 10px 0px 0px;
    }

    .ant-collapse-header {
      padding: 0px !important;
      p {
        margin: 0px;
      }
      > div:first-child {
        flex: 1;
        padding-left: 0px;
        padding-right: 0px;
        text-align: right;
        .anticon {
          margin: 0px;
        }
      }

      > div {
        padding: 10px;
      }

      .features {
        flex: 9;
      }

      .check {
        flex: 5;
        text-align: center;
      }
    }

    .ant-collapse-content-box {
      padding: 0px;
      span {
        display: flex;
        > div {
          text-align: center;
          padding: 10px;
        }
        .features {
          flex: 2;
          text-align: left;

          p {
            margin: 0px;
          }
        }
        .check {
          flex: 1;
        }
      }
    }

    svg {
      width: 16px;
    }

    .fa-check-circle {
      color: ${green};
    }

    .fa-circle-xmark {
      color: ${grey};
    }
  }

  @media (max-width: 1024px) {
    margin: 0px;
    margin-left: 5px;
    margin-right: 5px;
    .isMensuelWrapper {
      text-align: center;
    }
    .pricingCollapseHeader {
      font-size: 12px;
      > div {
        width: 25% !important;
      }
    }
  }
`;
